import { Person } from "@/Common/Models/Person/Person";
import { IListCreateAndEditItemModel } from "@/Lists/Models/UI/IListCreateAndEditItemModel";

import img_p_banner_icon_100 from "@/Globals/_images/p-banner-icon-100.png";

interface IListPatientInfoProps {
    Model?: IListCreateAndEditItemModel;
    Patient?: Person;
    // CancelOperation: number;
    // OkOperation: number;
}

class ListPatientInfoState {
    public priority: string;
    public comments: string;
}

class ListPatientInfo extends React.Component<IListPatientInfoProps, ListPatientInfoState> {
    constructor(props: IListPatientInfoProps) {
        super(props);

        const initialState = new ListPatientInfoState();
        initialState.comments = "";
        initialState.priority = "";
        this.state = initialState;
    }

    public render(): JSX.Element {
        var p = this.props.Patient;
        var patientDivClassName = "tb notselected";
        var address;
        var NextApp;

        var phone1;
        var phone2;
        var phone3;

        phone1 = p.Patient.GetFormattedPhonesByPriorityWithPosition(0);
        phone2 = p.Patient.GetFormattedPhonesByPriorityWithPosition(1);
        phone3 = p.Patient.GetFormattedPhonesByPriorityWithPosition(2);

        address = p.Patient.GetFormattedAddress();
        NextApp = p.Patient.GetNextAppointmentFormatted();

        var patientInfo = (
            <ul>
                {phone1 != "" && <li><span className="myle-icon-16 phone" /><span className="content-text">{phone1}</span></li>}
                {phone2 != "" && <li><span className="myle-icon-16 phone" /><span className="content-text">{phone2}</span></li>}
                {phone3 != "" && <li><span className="myle-icon-16 phone" /><span className="content-text">{phone3}</span></li>}
                {address != "" && <li><span className="myle-icon-16 pin" /><span className="content-text">{address}</span></li>}
                {NextApp != "" && <li><span className="myle-icon-16 none" /><span className="content-text">{NextApp}</span></li>}
            </ul>
        );

        return (
            <div>
                <div className={patientDivClassName} key={p.ContactId + "_"}>

                    <div className="tbc r1">
                        <img title={p.NameWithIdentifier} src={img_p_banner_icon_100} style={{ width: "48px" }} alt={p.NameWithIdentifier} />
                    </div>

                    <div className="tbc r2">
                        <h4 className="light-blue">{p.Name}<span className="myle-icon-16 female" /></h4>
                        <ul>
                            <li><strong>{sessionStore.getDefaultHealthCardLabel()} </strong><span>{p.GetFormattedNAM()} {p.Patient.GetFormattedNAMExpirationDateString()}</span></li>
                            <li><strong>{cacheStore.GetString("FileNumbersLabel")} </strong><span>{p.Patient.PatientResponse.Identifier01}</span></li>
                            <li><strong>{cacheStore.GetString("DateofBirthLabel")} </strong><span>{p.Patient.GetFormattedDateOfBirth() + " (" + p.Patient.GetFormattedAge() + ") "}</span></li>
                            <li><strong>{cacheStore.GetString("PhysicianNameLabel")} </strong><span>{p.Patient.GetFormattedRamqDoctorOrStatus()}</span></li>
                        </ul>
                    </div>

                    <div className="tbc r3">
                        {patientInfo}
                    </div>

                </div>
            </div>
        );
    }
}

export { ListPatientInfo };
